(function () {
    Titania = typeof (Titania) != "undefined" && Titania || {};
    Titania.Models = Titania.Models || {};
})();